import { IAnimationElementProps } from '../../../../../common/Animation';

export const layoutAnimationConfig: IAnimationElementProps = {
  initial: { opacity: 0, height: 1 },
  animate: {
    opacity: 1,
    height: 40,
    transition: {
      duration: 0.2,
    },
  },
  exit: {
    opacity: 0,
    height: 1,
    transition: {
      duration: 0.2,
    },
  },
};
